import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer, Provider } from '@angular/core';

import { AppContextService } from '@efficiently/client-api-app-context';

import { AppContextListenerService } from './app-context-listener.service';
import { AppContextStoreService } from './app-context-store.service';

/**
 * Provides app context services for dependency injection.
 * Registers AppContextStoreService as implementation of AppContextService.
 * AppContextListenerService is created eagerly via provideAppInitializer to start listening immediately.
 *
 * @example
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     ...appContextProviders,
 *     { provide: PermissionsService, useExisting: YourPermissionsServiceImpl },
 *   ]
 * };
 */
export const appContextProviders: Array<Provider | EnvironmentProviders> = [
	makeEnvironmentProviders([
		AppContextStoreService,
		{ provide: AppContextService, useExisting: AppContextStoreService },
	]),
	provideAppInitializer(() => {
		inject(AppContextListenerService);
	}),
];
